// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"129":"c884866e","267":"b9ea648d","345":"e94dcf78","580":"9517ee5f","763":"8d82ee84","996":"d2a38ab3"}[chunkId] + ".chunk.css";
};